import React from "react";
import { useQuery } from "@tanstack/react-query";
import { MessageCircle } from "lucide-react";
import api from "@/services/api";
import { useLang } from "@/context/LanguageContext";
import { DEFAULT_WA_ASSIST_MESSAGE, whatsappSendUrl } from "@/utils/whatsapp";

/**
 * Floating WhatsApp assistance button — uses Zelle `whatsapp` contact from admin settings.
 * Prefill is always the Julie/TGS default assist message (Kreyòl).
 */
export default function WhatsAppAssistButton() {
  const { t } = useLang();
  const { data: zelle } = useQuery({
    queryKey: ["zelle"],
    queryFn: async () => (await api.get("/zelle")).data,
    staleTime: 60_000,
  });

  const phone = zelle?.whatsapp || "";
  const url = whatsappSendUrl(phone, DEFAULT_WA_ASSIST_MESSAGE);
  if (!url) return null;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-assist-btn"
      aria-label={t("wa_assist") || "Asistans WhatsApp"}
      className="fixed z-50 bottom-5 right-4 sm:bottom-6 sm:right-6 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white font-semibold shadow-lg px-4 py-3 text-sm transition-transform hover:scale-[1.03] active:scale-[0.98]"
    >
      <MessageCircle className="h-5 w-5 shrink-0" />
      <span className="pr-0.5">{t("wa_assist") || "Asistans WhatsApp"}</span>
    </a>
  );
}
